import { BRAND_REFRESH_ACTIVATION_DATA_KEY } from './constants'

export interface BrandRefreshActivationData {
  opted_in?: boolean
  banner_started_at?: string
}

type ActivationDataRecord = Record<string, unknown> | null | undefined

export function readBrandRefreshActivationData(
  activationData: ActivationDataRecord,
): BrandRefreshActivationData {
  const blob = activationData?.[BRAND_REFRESH_ACTIVATION_DATA_KEY]
  if (blob == null || typeof blob !== 'object') {
    return {}
  }
  return blob as BrandRefreshActivationData
}

export function patchBrandRefreshActivationData(
  activationData: ActivationDataRecord,
  patch: Partial<BrandRefreshActivationData>,
): Record<string, unknown> {
  const existing = readBrandRefreshActivationData(activationData)

  return {
    ...(activationData ?? {}),
    [BRAND_REFRESH_ACTIVATION_DATA_KEY]: {
      ...existing,
      ...patch,
    },
  }
}

/** Resets beta state for debug clear — server merge keeps stale values if the blob is omitted. */
export function clearBrandRefreshActivationData(
  activationData: ActivationDataRecord,
  { nowMs = Date.now() }: { nowMs?: number } = {},
): Record<string, unknown> {
  return patchBrandRefreshActivationData(activationData, {
    opted_in: false,
    banner_started_at: new Date(nowMs).toISOString(),
  })
}
